@if (entity(); as entity) {
  <soft-page>
    <soft-page-header>
      <div class="soft-title mb-4 mt-4">
        {{ entity?.hauptartikel?.artbez1 }}
      </div>
    </soft-page-header>
    <section class="adaptive-grid">
      <div class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.CUSTOMER' | translate }}</strong>
        {{ entity?.ktostamm?.nummer }}
        @if (entity?.ktostamm?.bez1 && (entity?.ktostamm?.bez1?.length ?? 0) > 0) {
          <ng-container>
            - {{ entity?.ktostamm?.bez1 || '-' }}
            @if (entity?.ktostamm?.bez2 && (entity?.ktostamm?.bez2?.length ?? 0) > 0) {
              <ng-container>{{ entity?.ktostamm?.bez2 }}</ng-container>
            }
          </ng-container>
        }
      </div>
      <div class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.VERKAUFSART' | translate }}</strong>
        {{ entity?.verkaufsart?.verkaufsart || '-' }}
        @if (entity?.verkaufsart?.bezeichnung) {
          <ng-container>
            - {{ entity?.verkaufsart?.bezeichnung || '-' }}
          </ng-container>
        }
      </div>
      <div class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.USER_SHOP' | translate }}</strong>
        {{ entity?.kundenauftragsvkforg?.vkforg }}
        @if (entity?.kundenauftragsvkforg?.bez && (entity?.kundenauftragsvkforg?.bez?.length ?? 0) > 0) {
          <ng-container>
            - {{ entity?.kundenauftragsvkforg?.bez || '-' }}
          </ng-container>
        }
        <br>
        <span style="opacity: 0.75">{{ entity?.kundenauftragsvkforg?.anwender }}</span>
      </div>
      <div class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.CREATION_DATE' | translate }}</strong>
        {{ (entity?.belegdatum?.toString() | date:'dd.MM.YYYY') || '-' }}
      </div>
      <div
        class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3 cursor-pointer border border-solid border-primary"
        (click)="changePickUpDate(entity ?? '')"
      >
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.PICK_UP_DATE' | translate }}</strong>
        {{ (entity?.abholdatum?.toString() | date:'dd.MM.YYYY') || '-'   }}
      </div>
      <div class="soft-card rounded-sm flex flex-col pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.RECEIPT_NUMBER' | translate }}</strong>
        {{ entity?.extbestellnr || '-' }}
      </div>
    </section>

    <section class="mt-3">
      <div class="soft-card rounded-sm flex flex-col c column box-border no-wrap pt-3 pb-3 pr-3 pl-3">
        <strong class="soft-overline title">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.COMMENT' | translate }}</strong>
        {{  entity?.kommentar || '-' }}
      </div>
    </section>

    <section class="mt-3">
      <div
        class="soft-card rounded-sm flex flex-col c row space-between center-v box-border no-wrap"
        [ngClass]="{'!bg-primary opacity-60': entity?.kzgarantie === 'J'}">
        <div class="c column pointer" (click)="changeWarranty(entity)">
          <strong class="soft-overline"  [ngClass]="{'!text-primary-contrast': entity?.kzgarantie === 'J'}">
            {{ '#GOLDSCHMIEDE.KOPFAU.INFO.GARANTIE' | translate }}
          </strong>
          @if (isChangingWarranty() === 'saving') {
            <div class="flex flex-col w-full soft-card rounded-sm gap-3 mt-3">
              <div class="h-3 w-20 skeleton"></div>
            </div>
          } @else {
            <span [ngClass]="{'!text-primary-contrast': entity?.kzgarantie === 'J'}">{{ entity?.kzgarantie === 'J'  ? 'Ja (Garantie)' : 'Nein (keine Garantie)' }}</span>
          }
        </div>
      </div>
    </section>

    @if (entity?.lieferhinweis) {
      <section class="mt-3">
        <div class="soft-card rounded-sm flex flex-col grid-item pt-3 pb-3 pr-3 pl-3">
          <strong class="soft-overline">{{ '#GOLDSCHMIEDE.KOPFAU.INFO.DELIVERY_NOTE' | translate }}</strong>
          {{ entity?.lieferhinweis }}
        </div>
      </section>
    }

    <section class="mt-5">
      <div class="c row space-between center-v no-wrap">
        <strong class="overline-title">{{ '#GOLDSCHMIEDE.KOPFAU.GOLDSCHMIEDE_TEXT.HEADER' | translate }}</strong>
        <button class="soft-button primary mb-2 pointer" (click)="saveGoldschmiedeText(entity)">
          <i class="fas fa-check-circle mr-1"></i>
          {{ '#GOLDSCHMIEDE.KOPFAU.GOLDSCHMIEDE_TEXT.SAVE' | translate }}
        </button>
      </div>
      <soft-multiline-input
        [value]="entity?.goldschmiedeText ?? null"
        (valueChange)="updateGoldschmiedeText($event ?? '')"
        placeholder="Tippen um Anmerkungen/Hinweise/Informationen zu erfassen"
        [lines]="7">
      </soft-multiline-input>
    </section>

    @if (belegvermerke(); as belegvermerke) {
      <section class="margin-top">
        <div class="c row space-between center-v no-wrap">
          <strong class="soft-overline overline-title">{{ '#GOLDSCHMIEDE.KOPFAU.BELEGVERMERKE.HEADER' | translate }}</strong>
          <button class="soft-button primary mb-2 pointer" (click)="showCreateBelegvermerk(entity)">
            <i class="fas fa-plus-circle mr-1"></i>
            {{ '#GOLDSCHMIEDE.KOPFAU.BELEGVERMERKE.CREATE' | translate }}
          </button>
        </div>
        @for (belegvermerk of belegvermerke; track belegvermerk.id; let first = $first) {
          <ng-container class="mt-5">
            <div class="c column grid-item border-box" style="position: relative" [ngClass]="first ? '' : 'mt-2'">
              <div class="c pl-3 pr-3 row space-between center-v separator border-box pt-3 pb-3" style="background-color: #eeeeee">
                <span class="soft-text-xs soft-overline">{{ belegvermerk?.anwender }}</span>
                <div>
                  <span class="soft-text-xs color-light" style="text-align: right">
                    {{ belegvermerk?.erfzeit | date:'dd.MM.yyyy'}} &nbsp;/&nbsp; {{ belegvermerk?.erfzeit | date:'hh:mm'}} UHR
                  </span>
                </div>
              </div>
              <p class="mt-0 mb-0 pl-3 pr-3 border-box pt-3 pb-3">{{ belegvermerk?.vermerk }}</p>
            </div>
          </ng-container>
        } @empty {
          <div class="c column grid-item p-5">
            <div>{{ '#GOLDSCHMIEDE.KOPFAU.BELEGVERMERKE.EMPTY' | translate }}</div>
            <a class="soft-link mt-2" (click)="showCreateBelegvermerk(entity)">{{ '#GOLDSCHMIEDE.KOPFAU.BELEGVERMERKE.ADD' | translate }}</a>
          </div>
        }
      </section>
    }
    @if (entity?.hauptartikel) {
      <ng-container>
        <section class="mt-2 mb-2 pb-2 margin-top">
          <div class="c row space-between center-v no-wrap">
            <strong class="soft-overline overline-title">{{ '#GOLDSCHMIEDE.KOPFAU.ARTIKEL.HEADER' | translate }}</strong>
          </div>

          <div class="soft-card rounded-m mt-1">
            <soft-beweau-card
              [hauptartikel]="entity.hauptartikel"
              [images]="entity?.hauptartikel?.media || []"
              [price]="entity.vkpreis ?? undefined"
              [preisebene]="entity?.preisebene"
              [url]="entity?.hauptartikel?.url"
              (imageTapped)="showZoomDialog(entity.hauptartikel)"
              (priceTapped)="showChangePriceDialog(entity)"
              (beweausTapped)="showBeweaus()"
            ></soft-beweau-card>
          </div>
        </section>

        <section class="mt-1 mb-3 pb-1 margin-top">
          <div class="c row space-between center-v no-wrap mb-1 ">
            <strong class="soft-overline overline-title">{{ '#GOLDSCHMIEDE.KOPFAU.DOKUMENTE.HEADER' | translate }}</strong>
          </div>
          <soft-archive-list [archiveKey]="entity.archivekey | base64Encode"></soft-archive-list>
        </section>

        @if (timeReports(); as timeReports) {
          <section class="mb-5 pb-4 margin-top">
            <div class="c row space-between center-v no-wrap mb-1">
              <div class="c">
                <strong class="soft-overline overline-title">{{ '#GOLDSCHMIEDE.KOPFAU.ARBEITSZEITEN.HEADER' | translate }}</strong>
              </div>
            </div>
            <ng-container>
              @for (timeReport of timeReports; track timeReport.id) {
                <div class="soft-card rounded-m mt-1">
                  <div class="c row space-between center-v no-wrap">
                    <div class="c column truncate mr-3">
                      <strong class="soft-text truncate mb-1">{{ timeReport?.employee?.vorname }} {{ timeReport?.employee?.zuname }}</strong>
                      <span class="soft-text color-light">{{ timeReport.date | date:'dd.MM.yyyy' }}</span>
                    </div>
                    <div class="c row space-between">
                      <span class="soft-text text-right">{{ timeReport?.from | format: "TIME.DEFAULT" }} - {{ timeReport?.to | format: "TIME.DEFAULT" }}</span>
                      @if (timeReport?.duration) {
                        <span class="soft-text">{{ timeReport?.duration | duration }}</span>
                      }
                    </div>
                  </div>
                </div>
              } @empty {
                <div class="soft-card">
                  <div class="c row center">Noch keine Arbeitszeiten vorhanden</div>
                </div>
              }
            </ng-container>

            @if (timeReports && (timeReports?.length ?? 0) > 0) {
              <div class="c row end mt-2 mb-2 pb-3">
                <strong class="mr-3">
                  {{ timeSum() | format: "TIME.DEFAULT" || '00:00' }}
                </strong>
              </div>
            }
          </section>
        }
      </ng-container>
    } @else {
      <div class="flex flex-col w-full soft-card rounded-sm gap-3 mt-3">
        <div class="h-3 w-10 skeleton"></div>
        <div class="h-3 w-20 skeleton" *softRepeat="2"></div>
      </div>
    }
  </soft-page>

  <ng-template #loadingTemplate>
    <div class="flex flex-col w-full soft-card rounded-sm gap-3 mt-3">
      <div class="h-3 w-10 skeleton"></div>
    </div>
  </ng-template>
}